import { Component } from '@angular/core';
import { ApiService } from '../services/api.service';
import { CommonEventService } from '../services/common-event.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser'
import { FormGroup, FormControl, Validators , FormBuilder} from '@angular/forms';

import * as $ from 'jquery';
@Component({
  selector: 'app-order-status',
  templateUrl: './order-status.component.html',
  styleUrls: ['./order-status.component.css']
})
export class OrderStatusComponent {
  redirectUrl = '';
  // quoteSave : boolean = false;
  urlWrongPerson :any;
  updatePurchesCheck : boolean = false;
  updatePurchesFname:any;
  updatePurchesLname:any;
  updatePurchesEmail:any;
  updatePurchesRemarks:any;
  unauthDomain: string = '';
  unauthEmailisValid: boolean = false;

  constructor(
    public apiService : ApiService,
    private modalService: NgbModal,
    private sanitizer:DomSanitizer,
    public commonService : CommonEventService
    ){
      this.redirectUrl = this.commonService.commonMainObj.stagingPortalUrl+"home.jsp";
    }

  ngOnInit() {
    if(this.commonService.commonMainObj.orderPlacedData.orderNumber){
      if(this.commonService.commonMainObj.orderPlacedData.pendingPaymentMessage){
        this.urlWrongPerson = this.sanitizer.bypassSecurityTrustResourceUrl(this.commonService.commonMainObj.orderPlacedData.pendingPaymentResendMailLink)
        this.commonService.commonMainObj.orderPlacedData.pendingPaymentMessage1 = this.commonService.commonMainObj.orderPlacedData.pendingPaymentMessage.split("<br>")[0]
        this.commonService.commonMainObj.orderPlacedData.pendingPaymentMessage2 = this.commonService.commonMainObj.orderPlacedData.pendingPaymentMessage.split("<br>")[1]
        this.commonService.commonMainObj.orderPlacedData.pendingPaymentMessage3 = this.commonService.commonMainObj.orderPlacedData.pendingPaymentMessage.split("<br>")[2]
      }
      setTimeout(()=>{
        
        this.apiService.getNotificationData();
        this.apiService.gotoOrder();
        window.scrollTo(0, 0);
      
        // window.onbeforeunload = function () {
        //   window.scrollTo(0, 0);
        // }
      },500)
      this.updatePurchesFname = this.commonService.commonMainObj.purchasingPersonDetails.firstName ? this.commonService.commonMainObj.purchasingPersonDetails.firstName : this.apiService.apiMainObj.selectedBillingAddress.firstName;
      this.updatePurchesLname = this.commonService.commonMainObj.purchasingPersonDetails.lastName ? this.commonService.commonMainObj.purchasingPersonDetails.lastName : this.apiService.apiMainObj.selectedBillingAddress.lastName;
      this.updatePurchesEmail = this.commonService.commonMainObj.purchasingPersonDetails.email ? this.commonService.commonMainObj.purchasingPersonDetails.email : this.apiService.apiMainObj.selectedBillingAddress.email;
      this.updatePurchesRemarks = this.commonService.commonMainObj.purchasingPersonDetails.remarks;
    }else{
      this.commonService.goBack();
      // this.quoteSave = true;
    }
    
    this.commonService.restrictBrowserButtons();
    // this.commonService.restrictRefreshButton();
  }

  ngOnDestroy() {
    // this.commonService.destroyRefreshEvent();
  }
  close() {
    this.modalService.dismissAll();
  }
  
  unAuthorizedUpdateForm = new FormGroup({
    unAuthFirstName:new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(99), Validators.pattern('^[a-zA-Z ]*$')]),
    unAuthLasttName:new FormControl('', [Validators.minLength(0), Validators.maxLength(99), Validators.pattern('^[a-zA-Z ]*$')]),
    unAuthEmail:new FormControl('', [Validators.required, Validators.email, Validators.minLength(4), Validators.pattern(/^(?!\.)(?!.*\.\.)[a-zA-Z0-9_.-]{1,64}(?<!\.)@(?!(?:.*-[0-9]+\.){2,})(?=[a-zA-Z0-9-]{1,61}\.)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,63}$/)]),
    unAuthRemark:new FormControl('', [Validators.minLength(0), Validators.maxLength(1000)]),
  });

  not_auth_validation_messages = {
    'unAuthFirstName': [
      { type: 'required', message: 'Please enter purchasing person Name' },
      { type: 'minlength', message: 'Name must be at least 3 characters long.' },
      { type: 'maxlength', message: 'Name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Name must contain only letters.' }
    ],
    'unAuthLasttName': [
      { type: 'required', message: '' },
      //{ type: 'minlength', message: 'Name must be at least 3 characters long.' },
      { type: 'maxlength', message: 'Name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Name must contain only letters.' }
    ],
    'unAuthEmail': [
      { type: 'required', message: 'Please enter purchasing person Email.' },
      { type: 'minlength', message: 'Email must be at least 4 characters long.' },
      { type: 'maxlength', message: 'Email cannot be more than 25 characters long.' },
      { type: 'pattern', message: 'Please enter a valid email.' }
    ],
    'unAuthRemark': [
      // { type: 'required', message: 'Please fill Remarks' },
    ],
  }

  validateUnauthDomain(): void {
    this.unauthDomain = this.updatePurchesEmail;
    this.commonService.validateDomain(this.unauthDomain);
    setTimeout(() => {
      this.unauthEmailisValid = this.commonService.commonMainObj.invalidEmail;
    }, 500);
  }
  private newAttribute: any = {};
  addFieldValue() {
    this.commonService.commonMainObj.notificationData.push(
      {
        firstNmae    : "",
        lastName     : "",
        email        : "",
        phone        : "",
        dnd          : false,
        primary      : false,
        designer     : false,
        billing      : false,
        shipping     : false,
        engineer     : false,
        qualityCtrl  : false,
        twentyFourHrs: false,
        shareProject : false,
        newLine : true
        }  
    )
    this.newAttribute = {};
      
  }
    
  primaryChange(check:any,length:any, ind:any){
    let notificationListLength = length;
    let primaryCheckLength = 0;

    let primtCount = 0;
    let bothCount = 0;

    //this.dndTrueCount = 0;
    if(check == false){
      this.commonService.commonMainObj.primaryCheckCount['trueCount'] -= 1;
      for(let i=0; i< this.commonService.commonMainObj.notificationData.length; i++){
        // if(this.commonService.commonMainObj.notificationData[i].dnd == true){
        //   this.dndTrueCount += 1;
        // }

        if(this.commonService.commonMainObj.notificationData[i].primary == true){
          primtCount += 1;
        }
        if(this.commonService.commonMainObj.notificationData[i].primary == true && this.commonService.commonMainObj.notificationData[i].dnd == true){
         bothCount += 1;
        }

        if(this.commonService.commonMainObj.notificationData[i].primary == false || this.commonService.commonMainObj.notificationData[i].primary == 0){
          console.log("primaryFalseCount",primaryCheckLength += 1);
          if(notificationListLength == primaryCheckLength){
            this.commonService.commonMainObj.primaryCheckCount['trueCount'] += 1;
            setTimeout(() => {
              this.commonService.commonMainObj.notificationData[ind].primary = true;
            }, 500);
            alert("At least one Primary role should be available");
            return;
          }
        }
      }
      if(primtCount == bothCount || primtCount < bothCount){
        this.commonService.commonMainObj.primaryCheckCount['trueCount'] += 1;
        setTimeout(() => {
          this.commonService.commonMainObj.notificationData[ind].primary = true;
        }, 500);
        alert("At least one Primary role should be available");
      }
    }else{
      this.commonService.commonMainObj.primaryCheckCount['trueCount'] += 1;
    }

  }

  
  dndChange(dndCheck:any,length:any, ind:any){
    let notificationListLength = length;
    let dndCheckListCount = 0 ;
    console.log(notificationListLength);
    let primtCount = 0;
    let bothCount = 0;
    if(this.commonService.commonMainObj.primaryCheckCount['trueCount'] == 1 && dndCheck == true && this.commonService.commonMainObj.notificationData[ind].primary == true){
      setTimeout(() => {
        this.commonService.commonMainObj.notificationData[ind].dnd = false;
      }, 500);
      alert("You cannot set DND as there isn't any other contact set as Primary");
      return;
    }

    if(this.commonService.commonMainObj.primaryCheckCount['trueCount'] > 0 && dndCheck == true ){
      for(let i=0; i< this.commonService.commonMainObj.notificationData.length; i++){

        if(this.commonService.commonMainObj.notificationData[i].primary == true){
          primtCount += 1;
        }
        if(this.commonService.commonMainObj.notificationData[i].primary == true && this.commonService.commonMainObj.notificationData[i].dnd == true){
         bothCount += 1;
        }

        if(this.commonService.commonMainObj.notificationData[i].dnd == true){
          console.log("dndTrueCount",dndCheckListCount += 1);
          if(notificationListLength == dndCheckListCount){
            setTimeout(() => {
              this.commonService.commonMainObj.notificationData[ind].dnd = false;
            }, 500);
            alert("You cannot set DND as there isn't any other contact set as Primary");
            return;
          }
        }
      }
      if(primtCount == bothCount || primtCount < bothCount){
        setTimeout(() => {
          this.commonService.commonMainObj.notificationData[ind].dnd = false;
        }, 500);
        alert("You cannot set DND as there isn't any other contact set as Primary");
        return;
      }
      $('.DNDCHECK-'+ind).attr('disabled','true');
      $('.DNDCHECK-'+ind).parent().css('background','#CDCDCD');
    }else if(dndCheck == false){
      $('.DNDCHECK-'+ind).removeAttr('disabled');
      $('.DNDCHECK-'+ind).parent().css('background','#FFF');
    } 
  }

  deleteFieldValue(selectedIndx:any) {
    //if(this.checks==true){
      console.log("selectedIndx",selectedIndx);
      this.commonService.commonMainObj.notificationData.splice(parseInt(selectedIndx),1);
      for(var i=0; i<this.commonService.commonMainObj.notificationData.length; i++){
        //this.commonService.commonMainObj.notificationData.splice(parseInt(selectedIndx),1);
      }
    // }else{
    //   console.log("checks false");
    //   var indexVal = $('#selIndex').val();
    //   this.commonService.commonMainObj.notificationData.splice(indexVal, 1);
      
    // }
  }
  updateFieldValue(){
    this.commonService.sessionPortalLoad();
    var primaryChkCnt = 0;
    //var emailRgx = /^[a-zA-Z0-9._%+-]+@(?!(?:.*-[0-9]+\.)(?=.*[0-9]$))[a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.(?![0-9]+$)[a-zA-Z0-9]{2,63}$/;
    var emailRgx = /^(?!\.)(?!.*\.\.)[a-zA-Z0-9_.-]{1,64}(?<!\.)@(?!(?:.*-[0-9]+\.){2,})(?=[a-zA-Z0-9-]{1,61}\.)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,63}$/;
    var phoneRgx = /^\d*$/;
    var invalidPattern1 = /\d-.*\./;
    for(var i=0; i<this.commonService.commonMainObj.notificationData.length; i++){
      if(!this.commonService.commonMainObj.notificationData[i].email && !this.commonService.commonMainObj.notificationData[i].firstNmae && !this.commonService.commonMainObj.notificationData[i].lastName && !this.commonService.commonMainObj.notificationData[i].phone){
        $('#email'+i).addClass('input_req');
        $('#fName'+i).addClass('input_req');
        $('#lName'+i).addClass('input_req');
        $('#phoneNo'+i).addClass('input_req');
        alert('please fill all required fields');
        return false;
      }else{
        $('#email'+i).removeClass('input_req');
        $('#fName'+i).removeClass('input_req');
        $('#lName'+i).removeClass('input_req');
        $('#phoneNo'+i).removeClass('input_req');
      }
      if(!this.commonService.commonMainObj.notificationData[i].email){
        $('#email'+i).addClass('input_req');
        alert('Please fill email')
        return false;
      }else if(!this.commonService.commonMainObj.notificationData[i].email.includes('@') && this.commonService.commonMainObj.notificationData[i].email > 64){
        $('#email'+i).addClass('input_req');
        alert('Maximum length of the email local part should be less than equal to 64 characters');
        return false;
      }else if(!this.commonService.commonMainObj.notificationData[i].email.includes('@')){
        $('#email'+i).addClass('input_req');
        alert("Email id should have a local part and domain part separated by '@'. Example <local part>@<second level domain>.<top level domain>")
        return false;
      }else if(/^\./.test(this.commonService.commonMainObj.notificationData[i].email)){
        $('#email'+i).addClass('input_req');
        alert('Email should not start with a dot (.)');
        return false;
      }else if(/^\s|\s$|\s/.test(this.commonService.commonMainObj.notificationData[i].email)){
        $('#email'+i).addClass('input_req');
        alert('Email id cannot have spaces.');
        return false;
      }else if(this.commonService.commonMainObj.notificationData[i].email){
        var emailLocalPart = this.commonService.commonMainObj.notificationData[i].email.split("@")[0];
        var first_split = this.commonService.commonMainObj.notificationData[i].email.split("@")[1];
        //console.log("first_split",first_split);
        //const [domainPart, tldPart] = first_split.split('.');
        const  domainPart = first_split.split('.').slice(0, -1).join('.');
        const tldPart = first_split.split('.').pop();
        //localpart check
        if(/\.$/.test(emailLocalPart)){
          $('#email'+i).addClass('input_req');
          alert('Email local part should not end with a dot (.)');
          return false;
        }else if(emailLocalPart.length > 64){
          $('#email'+i).addClass('input_req');
          alert('Maximum length of the email local part should be less than equal to 64 characters');
          return false;
        }else if(/\.\./.test(emailLocalPart)){
          $('#email'+i).addClass('input_req');
          alert("Email should not contain consecutive dots (..)");
          return false;
        }else if(/[^a-zA-Z0-9_.-]/.test(emailLocalPart)){
          $('#email'+i).addClass('input_req');
          alert("Invalid characters contains at local part.");
          return false;
        }
        //domain part check
        if (first_split != '' && first_split != undefined && first_split.length + 1 > 63) {
          $('#email'+i).addClass('input_req');
          alert('Maximum email length should be less than equal to 63 characters.');
          return false;
        }else if(tldPart != '' && tldPart !=undefined && tldPart.match(/^\d+$/)){
          $('#email'+i).addClass('input_req');
          alert('Top-level-domain cannot be entirely numeric.');
          return false;
        }else if(!first_split.includes('.')){
          $('#email'+i).addClass('input_req');
          alert('Email id should have a dot (.) and top level domain should be present after the dot. Example <local part>@<second level domain>.<top level domain>');
          return false;
        }else if(tldPart == '' || tldPart == undefined){
          $('#email'+i).addClass('input_req');
          alert('Missing Top-level-domain.');
          return false;
        }else if(tldPart == '' || tldPart == undefined || tldPart.length < 2){
          $('#email'+i).addClass('input_req');
          alert('Top-level-domain should contain mininmum 2 characters.');
          return false;
        }else if(domainPart.substring(0, 1).match("-")){
          $('#email'+i).addClass('input_req');
          alert('First character of email domain cannot be a hyphen.');
          return false;
        }else if(domainPart.slice(-1).match("-")){
          $('#email'+i).addClass('input_req');
          alert('Last character of email domain cannot be a hyphen.');
          return false;
        }else if(first_split.slice(-1).match("-")){
          $('#email'+i).addClass('input_req');
          alert('Last character of email domain cannot be a hyphen.');
          return false;
        }else if(domainPart.substring(0, 1).match("\\d") && invalidPattern1.test(first_split)){
          $('#email'+i).addClass('input_req');
          alert('First character of email domain is numeric, so hyphen is not allowed.');
          return false;
        }else if(tldPart != '' && tldPart != undefined && tldPart.length < 2){
          $('#email'+i).addClass('input_req');
          alert('Top-level domain should contain mininmum 2 characters');
          return false;
        }
      }else if(emailRgx.test(this.commonService.commonMainObj.notificationData[i].email)== false){
        $('#email'+i).addClass('input_req');
        alert('Please enter a valid email.')
        return false;
      }else{
        if($('#email'+i).hasClass('input_req')){
          $('#email'+i).removeClass('input_req');
        }
      }
      if(!this.commonService.commonMainObj.notificationData[i].firstNmae){
        if($('#email'+i).hasClass('input_req')){
          $('#email'+i).removeClass('input_req');
        }
        $('#fName'+i).addClass('input_req');
        alert('please fill First Name')
        return false;
      }else{
        if($('#fName'+i).hasClass('input_req')){
          $('#fName'+i).removeClass('input_req');
        }
      }
      if(!this.commonService.commonMainObj.notificationData[i].lastName){
        if($('#fName'+i).hasClass('input_req')){
          $('#fName'+i).removeClass('input_req');
        }
        $('#lName'+i).addClass('input_req');
        alert('please fill Last Name')
        return false;
      }else{
        if($('#lName'+i).hasClass('input_req')){
          $('#lName'+i).removeClass('input_req');
        }
      }
      if(!this.commonService.commonMainObj.notificationData[i].phone){
        if($('#lName'+i).hasClass('input_req')){
          $('#lName'+i).removeClass('input_req');
        }
        $('#phoneNo'+i).addClass('input_req');
        alert('Please fill Phone Number')
        return false;
      }else if(this.commonService.commonMainObj.notificationData[i].phone.length < 10){
        $('#phoneNo'+i).addClass('input_req');
        alert('Phone number must be at least 10 numeric long.')
        return false;
      }else if(this.commonService.commonMainObj.notificationData[i].phone.length > 10){
        $('#phoneNo'+i).addClass('input_req');
        alert('Phone number cannot be more than 10 numeric long.')
        return false;
      }else if(phoneRgx.test(this.commonService.commonMainObj.notificationData[i].phone) == false){
        $('#phoneNo'+i).addClass('input_req');
        alert('Special characters are not allowed in phone number')
        return false;
      }else{
        if($('#phoneNo'+i).hasClass('input_req')){
          $('#phoneNo'+i).removeClass('input_req');
        }
      }
      if(this.commonService.commonMainObj.notificationData[i].primary == true){
        primaryChkCnt += 1;
      }

    }
    if(primaryChkCnt == 0){
      this.commonService.alertCall('Alert!!',"At least one Primary role should be available");
      return;
    }else{
      this.commonService.sessionPortalLoad();
      this.commonService.loadingShow();
      setTimeout(()=>{
        this.commonService.loadingHide();
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{
          if(data.status == 1){
            this.apiService.updateNotificationDetails().then((reqData: any)=>{
              // console.log("reqData",reqData);
              for(var i=0; i<this.commonService.commonMainObj.notificationData.length; i++){
                this.commonService.commonMainObj.notificationData[i].newLine = false;
              }
            });
          }
        },error =>{
          console.log('Error in checking user session', error);     
        })
      },1000);
    }
  }
  
  gotWrongPersonMail(content:any){
    this.commonService.loadingShow();
    this.apiService.checkPaymentStatus().subscribe((payMSts: any)=>{
      if(payMSts.paymentStatus == 'Pending'){
        this.paymentUserUpdate(content);
      }else{
        this.commonService.loadingHide();
        this.commonService.alertCall('Alert!!','Payment is already done for this order. Purchasing payment details cannot be updated now.');
      }
    });
  }
  

  paymentUserUpdate(content:any){
    this.commonService.loadingHide();
    this.updatePurchesFname = this.commonService.commonMainObj.purchasingPersonDetails.firstName ? this.commonService.commonMainObj.purchasingPersonDetails.firstName : this.apiService.apiMainObj.selectedBillingAddress.firstName;
    this.updatePurchesLname = this.commonService.commonMainObj.purchasingPersonDetails.lastName ? this.commonService.commonMainObj.purchasingPersonDetails.lastName : this.apiService.apiMainObj.selectedBillingAddress.lastName;
    this.updatePurchesEmail = this.commonService.commonMainObj.purchasingPersonDetails.email ? this.commonService.commonMainObj.purchasingPersonDetails.email : this.apiService.apiMainObj.selectedBillingAddress.email;
    this.updatePurchesRemarks = this.commonService.commonMainObj.purchasingPersonDetails.remarks;
      // commonService.commonMainObj.orderPlacedData.pendingPaymentResendMailLink
    var modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "update-purches-modal"})
    modalRef.result.then((result) => {
      // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      this.unAuthorizedUpdateForm.reset();
    });
  }
  updateResendEmail(){
    this.commonService.loadingShow();
    var updateObj = {
      "email": this.updatePurchesEmail,
      "firstName": this.updatePurchesFname,
      "lastName": this.updatePurchesLname,
      "paymentPending": "1",
      "remark": this.updatePurchesRemarks
    }
    this.apiService.updateAndResendNotAuth(updateObj).subscribe((data: any)=>{
      this.commonService.loadingHide();
      console.log("Updated Data", data);
      this.updatePurchesCheck = true;
      this.commonService.commonMainObj.purchasingPersonDetails.email = data.email;
      this.commonService.commonMainObj.purchasingPersonDetails.firstName = data.firstName;
      this.commonService.commonMainObj.purchasingPersonDetails.lastName = data.lastName;
      this.commonService.commonMainObj.purchasingPersonDetails.remarks = data.remark;
      this.close();
    },err=>{
      this.commonService.loadingHide();
      console.log(err);
      setTimeout(() => {
        this.close();
      }, 1000);
      this.commonService.alertCall('Alert!!',err);
    });
  }

}
